import { Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export const Table = (theme: Theme) => {
  return {
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: "separate"
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "none",

          color: "black !important",
          //borderColor: theme.palette.border.light
        },
        head: {
          height: "48px !important",
          color: theme.palette.text.secondary,
          //backgroundColor: "transparent",
          backgroundColor: theme.palette.background.paper,
          //borderTop: `1px solid ${theme.palette.border.main}`,
          borderBottom: `1px solid ${theme.palette.border.main}`,
          paddingTop: theme.spacing(0.5),
          paddingBottom: theme.spacing(0.5),
          "&:first-of-type": {
            //paddingLeft: theme.spacing(3),
            // borderTopLeftRadius: theme.shape.borderRadius,
            // borderBottomLeftRadius: theme.shape.borderRadius,
            //boxShadow: `inset 8px 0 0 ${theme.palette.background.paper}`,
          },
          "&:last-of-type": {
            //paddingRight: theme.spacing(3),
            // borderTopRightRadius: theme.shape.borderRadius,
            // borderBottomRightRadius: theme.shape.borderRadius,
            //boxShadow: `inset -8px 0 0 ${theme.palette.background.paper}`,
          },
        },
        body: {
          height: 48,
          paddingTop: theme.spacing(0.5),
          paddingBottom: theme.spacing(0.5),
          borderBottom: `1px solid ${theme.palette.border.main}`,

          "&:first-of-type": {
            paddingLeft: theme.spacing(3),
          },
          "&:last-of-type": {
            paddingRight: theme.spacing(3),
          },
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& .MuiTableRow-root:first-of-type .MuiTableCell-root": {
            borderTop: "none !important",
          },
          "& .MuiTableRow-root:last-of-type .MuiTableCell-root": {
            borderBottom: "none !important",
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          //borderTop: `solid 1px ${theme.palette.divider}`,
          borderTop: "none !important",
          height: "auto",
        },
        toolbar: {
          height: 50,
        },
        select: {
          "&:focus": {
            borderRadius: theme.shape.borderRadius,
          },
        },
        selectIcon: {
          width: 20,
          height: 20,
          marginTop: -4,
        },
      },
    },
  };
};
